import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

class EmisorSerieListItemActions extends Component {
  handleOnClick = () => {
    this.props.onDeleteRequest();
  };

  render() {
    return (
      <Button
        type="button"
        variant="secondary"
        onClick={this.handleOnClick}
      >
        Eliminar
      </Button>
    );
  }
}

export default EmisorSerieListItemActions;
